import React from "react";
import { Link } from "react-router-dom";

const Ocenjevanje = () => {
	return (
		<div>
			<div className='ocena-ucitelj'>
				<h1>Izberi učitelja</h1>
				<Link className='ucitelj' to='./ocenjevanje-kerstein'>
					KERSTEIN
				</Link>
				<Link className='ucitelj-ursic' to='./ocenjevanje-ursic'>
					URŠIČ
				</Link>
				<Link className='ucitelj-stanko' to='./ocenjevanje-stanko'>
					STANKO
				</Link>
			</div>
		</div>
	);
};

export default Ocenjevanje;
